import cache, { Cache } from './cache';
import ImageVolume from './classes/ImageVolume';
import { Surface } from './classes/Surface';

export { ImageVolume, Cache, Surface };
export default cache;
